import List from "./pages/List";
import WizardRoute from "./pages/Wizard/WizardRoute";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["INSTANCE_MODULE"],
  },
  {
    path: ":id/*",
    element: WizardRoute,
    permissions: ["INSTANCE_MODULE"],
  },
];

export default routes;
